/* eslint-disable camelcase */
/* eslint-disable react/no-array-index-key */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Cookies from 'js-cookie';
import Prismic from 'prismic-javascript';

import Hero from '../components/Home/Hero';
import Subscribe from '../components/Home/Subscribe';
import TiledSectionHeader from '../components/FlexLeague/TiledSectionHeader';
import TiledSection from '../components/Home/TiledSection';
import GetInTouch from '../components/FlexLeague/GetInTouch';
import InfoCards from '../components/FlexLeague/InfoCards';
import ClubLocator from '../components/ClubLocator';
import head from '../components/Meta';
import flagContainer from '../flagContainer';
import config from '../config';

import RenderPrismicContent from '../components/RenderPrismicContent';
import { getBackgroundClass } from '../utils/styling';

import * as homepageActions from '../redux/actions/homepage-actions';
import * as resourceActions from '../redux/actions/resource-actions';
import { getFlexLeaguePageContent } from '../redux/actions/v2/flexleague-actions';
import { TierTypes } from '../constants/clubs';

// import styles from './flex-leagues.module.scss';

class FlexLeague extends Component {
    static async getInitialProps({ store, query }) {
        const { homepage, resources, flexLeaguePageV2 } = store.getState();
        if (!(homepage && homepage.homepageContentLoaded)) {
            await store.dispatch(homepageActions.fetchHomepageContent());
        }
        if (!(resources && resources.resourceContent && resources.resourceContent.players)) {
            await store.dispatch(resourceActions.fetchResourceContent());
        }

        if (!(flexLeaguePageV2 && flexLeaguePageV2.loaded)) {
            await store.dispatch(getFlexLeaguePageContent());
        }
        return { query };
    }

    componentDidMount() {
        const previewRef = Cookies.get(Prismic.previewCookie);
        if (previewRef) {
            const previewObj = JSON.parse(previewRef);
            if (previewObj['myutrcom.prismic.io']) {
                this.props.fetchHomepageContent(previewObj['myutrcom.prismic.io'].preview);
            }
        }
        console.log(this.props);
    }

    render() {
        const { homepage, flexLeaguePageV2 } = this.props;
        const tabContent = (homepage && homepage.homepageContent && homepage.homepageContent.tabs && homepage.homepageContent.tabs.flexleague) || {};
        const themeV2 = flagContainer.themeV2.isEnabled();
        console.log('flex-leagues props', this.props);

        return (
            <div className={`${themeV2 && getBackgroundClass(flexLeaguePageV2.content)}`}>
                {themeV2
                    ? (
                        <RenderPrismicContent contentSlices={flexLeaguePageV2.content} />
                    )
                    : (
                        <>
                            {head({
                                title: 'UTR Flex League',
                                description: 'Get rated, find play, post scores, showcase your tennis, track progress, arrange tennis with friends and more',
                                keywords: 'UTR rating, Find UTR tennis events, UTR post score',
                                image: `https://www.${config.siteBaseUrl}/img/v2/ut-logo2.svg`,
                                imageWidth: '930',
                                imageHeight: '395',
                            })}
                            <Hero
                                heroImage={tabContent.image}
                                topline={tabContent.topline}
                                maintitle={tabContent.maintitle}
                                subtitle={tabContent.subtitle}
                                primaryctacopy={tabContent.primaryctacopy}
                                primaryctalink={tabContent.primaryctalink}
                                secondaryctalink={tabContent.secondaryctalink}
                                secondaryctacopy={tabContent.secondaryctacopy}
                            />
                            <div className={'mt32'}>
                                <ClubLocator
                                    tier_type_id={TierTypes.FlexLeague.id}
                                />
                            </div>
                            <div className={'mt78'}>
                                <TiledSectionHeader />
                                <InfoCards
                                    infoCards={tabContent.info_cards}
                                    clampValue={3}
                                />
                                <div className={`mt78`}>
                                    {tabContent.sections.map((section, i) => {
                                        if (i >= 1) return <TiledSection section={section} key={`section-${i}`} />;
                                        return null;
                                    })}
                                </div>
                                <GetInTouch />
                                <Subscribe />
                            </div>
                        </>
                    )}
            </div>
        );
    }
}

function mapStateToProps({ homepage, resources, flexLeaguePageV2 }) {
    return { homepage, resources, flexLeaguePageV2 };
}

function mapDispatchToProps(dispatch) {
    return {
        fetchHomepageContent: token => {
            dispatch(homepageActions.fetchHomepageContent(token));
        },
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(FlexLeague);
